<template>
  <div
    class="phone-header"
    :class="{ on_company: getToolbar.user.account_type == 3 }"
  >
    <!-- Feed -->
    <div class="item">
      <router-link to="/feeds">
        <img
          src="@/assets/icons/menu_icons/home.svg"
          v-if="$route.name !== 'feeds'"
          class="icon"
        />
        <img
          src="@/assets/icons/menu_icons/home_active.svg"
          v-if="$route.name === 'feeds'"
          class="icon"
        />
      </router-link>
    </div>
    <!-- Messages -->
    <div class="item">
      <router-link to="/messages">
        <img
          src="@/assets/icons/menu_icons/mail.svg"
          v-if="$route.name !== 'messages'"
          class="icon"
        />
        <img
          src="@/assets/icons/menu_icons/mail_active.svg"
          v-if="$route.name === 'messages'"
          class="icon"
        />
        <div class="badge" v-show="getToolbar.messages > 0">
          {{ getToolbar.messages | validate }}
        </div>
      </router-link>
    </div>
    <!-- Notifications -->
    <div class="item">
      <router-link to="/notifications">
        <img
          src="@/assets/icons/menu_icons/notification.svg"
          v-if="$route.name !== 'notifications'"
          class="icon"
        />
        <img
          src="@/assets/icons/menu_icons/notification_active.svg"
          v-if="$route.name === 'notifications'"
          class="icon"
        />
        <div
          class="badge"
          v-show="
            getToolbar.notifications.length > 0 &&
            $route.name !== 'notifications'
          "
        >
          {{ getToolbar.notifications.length | validate }}
        </div>
      </router-link>
    </div>

    <!-- profile -->
    <div
      class="item"
      v-if="getToolbar.user.account_type == 1"
      @click="$router.push({ name: 'consultant-profile' })"
    >
      <img
        v-if="getToolbar.user.profile_picture"
        :src="$fullUrl('images/profiles/' + getToolbar.user.profile_picture)"
        class="profile-img"
        :class="{ active: $route.name === 'consultant-profile' }"
      />
      <img
        v-else
        src="../../assets/avatar.png"
        alt
        :class="{ active: $route.name === 'consultant-profile' }"
        class="profile-img"
      />
    </div>

    <!-- profile -->
    <div
      class="item"
      v-if="getToolbar.user.account_type == 2"
      @click="$router.push({ path: '/profile/customer' })"
    >
      <img
        v-if="getToolbar.user.profile_picture"
        :src="$fullUrl('images/profiles/' + getToolbar.user.profile_picture)"
        class="profile-img"
        :class="{ active: $route.name === 'consultant-profile' }"
      />
      <img
        v-else
        src="../../assets/avatar.png"
        alt
        :class="{ active: $route.name === 'consultant-profile' }"
        class="profile-img"
      />
    </div>

    <!-- profile -->
    <div
      class="item"
      v-if="getToolbar.user.account_type == 3"
      @click="$router.push({ path: '/crm' })"
    >
      <img
        v-if="getToolbar.company.logo"
        :src="$fullUrl('images/profiles/' + getToolbar.company.logo)"
        class="profile-img"
        :class="{ active: $route.name === 'consultant-profile' }"
      />
      <img
        v-else
        src="../../assets/avatar.png"
        alt
        :class="{ active: $route.name === 'consultant-profile' }"
        class="profile-img"
      />
    </div>

    <!-- profile -->
    <div
      class="item"
      v-if="getToolbar.user.account_type == 4"
      @click="$router.push({ name: 'consultant-profile' })"
    >
      <img
        v-if="getToolbar.user.profile_picture"
        :src="$fullUrl('images/profiles/' + getToolbar.user.profile_picture)"
        class="profile-img"
        :class="{ active: $route.name === 'consultant-profile' }"
      />
      <img
        v-else
        src="../../assets/avatar.png"
        alt
        :class="{ active: $route.name === 'consultant-profile' }"
        class="profile-img"
      />
    </div>

    <!-- Settings -->
    <div class="item">
      <div class="settings">
        <img
          class="icon"
          @click="hideMenu = !hideMenu"
          src="@/assets/icons/menu_icons/settings.svg"
          ref="bt-toggle-menu"
          v-if="!hideMenu"
        />
        <img
          class="icon"
          src="@/assets/icons/menu_icons/settings_active.svg"
          v-if="hideMenu"
          ref="bt-toggle-menu"
          @click="hideMenu = !hideMenu"
        />
        <div
          class="__dropdown-results"
          v-show="hideMenu"
          @click="hideMenu = !hideMenu"
          v-closable="{
            exclude: ['bt-toggle-menu'],
            handler: 'hideDropDownMenu',
          }"
        >
          <div class="__dropdown-item">
            <a @click="$router.push({ name: 'settings' })">
              <span>Settings</span>
            </a>
          </div>
          <div class="__dropdown-item">
            <a @click.prevent="logOut">
              <span>Log out</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "@/router.js";

export default {
  name: "header-two",
  sockets: {
    connect: function () {},
    notification: function (payload) {
      if (payload.id === this.userId) {
        // this.$store.dispatch("SET_TITLE_BAR_INFO", {notifications : this.getToolbar.notifications + 1,
        //   unreads : this.getToolbar.unreads})
        console.log("notified" + payload);
      }
    },
    message: function (payload) {
      if (payload.id === this.userId && this.$route.name !== "messages") {
        this.$store.dispatch("SET_TITLE_BAR_INFO", {
          messages: this.getToolbar.messages + 1,
        });
        this.playSound();
      }
    },
    network: function (payload) {
      if (payload.id === this.userId) {
        this.networks = this.networks + 1;
      }
    },
    logOut() {
      this.$store.dispatch("AUTH_LOGOUT");
      this.$cookies.remove("project-token");
      this.$cookies.remove("employment-token");
      this.$router.push({ name: "login" });
    },
  },
  data() {
    return {
      audio: null,
      isEditing: false,
      toggleSearch: true,
      showNotification: false,
      model: null,
      hideSearch: true,
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      searchHeader: null,
      menus: [
        { title: "Profile", path: "user-profile" },
        //TODO:make a logout url
        { title: "Logout", path: "user-profile" },
      ],
      overflows: [
        { title: "Home", path: "/feeds" },
        { title: "Network", path: "/network" },
        { title: "Messages", path: "/messages" },
        { title: "Notification", path: "/notifications" },
      ],
      hideMenu: false,
    };
  },
  computed: {
    ...mapGetters(["getConsultants", "getTags", "getToolbar"]),
    userId() {
      return this.getToolbar.user.id;
    },
    userType() {
      return this.getToolbar.user.account_type === 1;
    },
    fields() {
      //   console.log(this.model)
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key],
        };
      });
    },
  },
  methods: {
    hide() {
      this.hideSearch = false;
    },
    viewNotification(id) {
      this.showNotification = false;
      this.$router.push({ name: "notification-view", params: { id: id } });
    },
    declineNotification(id) {
      this.$store.dispatch("DECLINE_TOBE_MEMBER", { id: id });
      this.showNotification = false;
    },
    hideDropDownMenu() {
      this.hideMenu = false;
    },
    checkLogout(route) {
      if (route === "Logout") {
        return true;
      }
    },
    moveto() {
      this.$router.push({ name: "people_search" });
    },
    newRoute(path) {
      router.push(path);
    },
    gotoProfile(id) {
      this.hideSearch = true;
      this.searchHeader = "";
      this.$router.push({ name: "profile-view", params: { id: id } });
    },
    gotoTag(tag) {
      this.hideSearch = true;
      this.searchHeader = "";
      this.$router.push({ name: "feeds", params: { tag: tag } });
    },
    logOut() {
      let vm = this;
      vm.$store.dispatch("AUTH_LOGOUT");
      vm.$cookies.remove("project-token");
      vm.$cookies.remove("employment-token");
      vm.$localStorage.remove("logged_user_data");
      vm.$router.push({ name: "login" });
    },
    manageDialogSearch(dial) {
      this.$store.dispatch("DIALOG_SEARCH", dial);
    },
    showDialogSearch() {
      this.manageDialogSearch(!this.getDialogSearch);
    },
    outside: function (e) {
      this.manageDialogSearch(false);
    },
    accept(notification) {
      this.$store.dispatch("GRANT_PERMISSION", { member: notification });
    },
    decline() {},
    hideResults() {
      this.hideSearch = true;
    },
    playSound() {
      this.audio.play();
    },
  },
  watch: {
    searchHeader: function (val) {
      if (val !== "" && val !== " ") {
        this.hideSearch = false;
        if (!val.startsWith("#")) {
          this.toggleSearch = true;
          this.$store.dispatch("POST_SEARCH_CONSULTANTS", { query: val });
        } else {
          this.toggleSearch = false;
          this.$store.dispatch("POST_SEARCH_TAGS", { query: val.substring(1) });
        }
      }
    },
  },
  mounted() {
    this.audio = new Audio(require("@/assets/audio/sound.mp3"));
    this.$socket.emit("register", this.userId);
  },
  created() {
    this.$store.dispatch("TITLE_BAR_INFO");
  },
};
</script>

<style lang="scss" scoped>
.phone-header {
  display: none;
  @media (min-width: 300px) and (max-width: 630px) {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 56px;
    background: #ffffff;
    z-index: 99999;
    display: grid;
    grid-template-columns: 20% 20% 20% 20% 20%;
    border-top: 6px solid #f7f7f7;
    &.on_company {
      grid-template-columns: 16.666% 16.666% 16.666% 16.666% 16.666% 16.666%;
    }
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    img.icon {
      width: 20px;
      height: 20px;
    }

    img.profile-img {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      object-fit: cover;
    }
    img.profile-img.active {
      border: 3px solid #0884af;
      padding: 2px;
    }
    .badge {
      background: #ff1d1d;
      position: absolute;
      top: 8%;
      right: 28%;
      height: 16px;
      min-width: 16px;
      color: #fff;
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      border-radius: 50%;
      padding: 3px 3px;
    }

    .settings {
      position: relative;
      .__dropdown-results {
        position: fixed;
        bottom: 52px;
        background: #fff;
        right: 19px;
        z-index: 9999999999999999;
        box-shadow: 0px 0px 3px #c8c8c8;
        border-radius: 5px;
        .__dropdown-item {
          width: 100px;
          &:hover {
            background: #ddd;
          }
          a {
            color: #000;
            text-decoration: none;
            padding: 15px 15px;
            display: block;
          }
        }
      }
    }
  }
}
</style>